module.exports = "/images/vendor/flag-icon-css/flags/1x1/ca.svg?8678fc67f7ebd50a5fc7c12a39ab93a2";